const calendlyApi = '/calendly';

export const calendlyLink = () => `${calendlyApi}/links`;
